module.exports = __webpack_public_path__ + "img/image-bank.f1aed53e.png";